import axios from "axios"
import javaHost, { baohuoJavaHost, nodeTTSHost } from '@/bin/javaSetting';
import { addRequestLog } from './jmx';
axios.interceptors.request.use((config) => {
    addRequestLog(config)
    return config
})
export function proxyUrl(url) {
    if (url.indexOf('http') === 0) {
        return url
    }
    if (url.indexOf('/apis') === 0) {
        return javaHost + url.split('/apis')[1]
    }
    if (url.indexOf('/baohuo-apis') == 0) {
        return baohuoJavaHost + url.split('/baohuo-apis')[1]
    }
    if (url.indexOf('/nodetts-apis') == 0) {
        return nodeTTSHost + url.split('/nodetts-apis')[1]
    }
    return url
}
export function mockData(data, delay = 200) {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(data)
        }, delay || Math.random() * 200 + 200)
    })
}
export default axios